<template>
  <v-simple-table class="mt-4 my-table" dense>
    <template #default>
      <thead class="table-heading">
        <tr class="th-auto">
          <th
            v-for="(cell, index) in headers"
            :key="`head-${index}`"
            rowspan="2"
            class="text-center boder-x-none text-dark"
          >
            <b>{{ cell.text }}</b>
          </th>
        </tr>
        <tr v-if="subheader" class="custom-row2 th-auto">
          <th rowspan="2" class="text-center boder-x-none text-dark">
            <b>%&nbsp;de<br />clientes&nbsp;con <br />pago&nbsp;vía<br />IEL</b>
          </th>
        </tr>
      </thead>
      <tbody v-if="!loading" class="custom-white-table">
        <slot />
      </tbody>
      <tbody v-else>
        <tr>
          <td colspan="10">
            <v-progress-linear indeterminate color="cyan" />
          </td>
        </tr>
      </tbody>
    </template>
  </v-simple-table>
</template>

<script>
  export default {
    name: 'IELTable',
    props: {
      loading: {
        type: Boolean,
        default: false,
      },
      headers: {
        type: Array,
        default: () => [],
      },
      subheader: {
        type: Array,
        default: null,
      },
    },
  };
</script>
